<template>
    <div class="emplacement-cascading-filter">
        <!-- Niveau 1 -->
        <div class="form-group">
            <label>Zone de stockage (Niveau 1)</label>
            <select class="form-control" v-model="selectedLevel1" @change="onLevel1Change" :disabled="loading">
                <option value="">— Choisir —</option>
                <option v-for="emp in level1Options" :key="emp.id" :value="emp.id">
                    {{ emp.name }}{{ emp.code ? ' (' + emp.code + ')' : '' }}
                </option>
            </select>
        </div>

        <!-- Niveau 2 -->
        <div class="form-group">
            <label>Sous-zone (Niveau 2)</label>
            <select class="form-control" v-model="selectedLevel2" @change="onLevel2Change" :disabled="loading || !selectedLevel1">
                <option value="">— Toutes —</option>
                <option v-for="emp in level2Options" :key="emp.id" :value="emp.id">
                    {{ emp.name }}{{ emp.code ? ' (' + emp.code + ')' : '' }}
                </option>
            </select>
        </div>

        <!-- Niveau 3 -->
        <div class="form-group">
            <label>Emplacement (Niveau 3)</label>
            <select class="form-control" v-model="selectedLevel3" @change="onLevel3Change" :disabled="loading || !selectedLevel2">
                <option value="">— Tous —</option>
                <option v-for="emp in level3Options" :key="emp.id" :value="emp.id">
                    {{ emp.name }}{{ emp.code ? ' (' + emp.code + ')' : '' }}
                </option>
            </select>
        </div>

        <!-- Hidden input for form submission -->
        <div class="form-group" style="display:none;">
            <label>Zone de stockage</label>
            <input type="hidden" name="emplacement_id" :value="selectedEmplacementId">
        </div>
    </div>
</template>

<script>
export default {
    name: 'emplacement-cascading-filter',
    props: {
        initialValue: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            loading: true,
            emplacements: [],
            selectedLevel1: '',
            selectedLevel2: '',
            selectedLevel3: ''
        };
    },
    computed: {
        level1Options() {
            return this.emplacements.filter(e => !e.parent_id);
        },
        level2Options() {
            if (!this.selectedLevel1) return [];
            return this.emplacements.filter(e => e.parent_id === parseInt(this.selectedLevel1));
        },
        level3Options() {
            if (!this.selectedLevel2) return [];
            return this.emplacements.filter(e => e.parent_id === parseInt(this.selectedLevel2));
        },
        selectedEmplacementId() {
            if (this.selectedLevel3) return this.selectedLevel3;
            if (this.selectedLevel2) return this.selectedLevel2;
            if (this.selectedLevel1) return this.selectedLevel1;
            return '';
        }
    },
    mounted() {
        this.fetchEmplacements();
    },
    methods: {
        fetchEmplacements() {
            this.loading = true;
            fetch('/api/emplacements/tree', {
                method: 'GET',
                ...this.getHttpJsonRequestHeaders()
            })
            .then(response => {
                if (!response.ok) throw new Error("Impossible de charger les emplacements.");
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    this.emplacements = data.emplacements;
                    this.restoreInitialValue();
                }
                this.loading = false;
            })
            .catch(() => {
                this.loading = false;
            });
        },
        restoreInitialValue() {
            if (!this.initialValue) return;
            const targetId = parseInt(this.initialValue);
            const target = this.emplacements.find(e => e.id === targetId);
            if (!target) return;

            if (!target.parent_id) {
                this.selectedLevel1 = String(target.id);
            } else {
                const parent = this.emplacements.find(e => e.id === target.parent_id);
                if (parent && !parent.parent_id) {
                    this.selectedLevel1 = String(parent.id);
                    this.selectedLevel2 = String(target.id);
                } else if (parent) {
                    const grandParent = this.emplacements.find(e => e.id === parent.parent_id);
                    if (grandParent) {
                        this.selectedLevel1 = String(grandParent.id);
                        this.selectedLevel2 = String(parent.id);
                        this.selectedLevel3 = String(target.id);
                    }
                }
            }
        },
        onLevel1Change() {
            this.selectedLevel2 = '';
            this.selectedLevel3 = '';
        },
        onLevel2Change() {
            this.selectedLevel3 = '';
        },
        onLevel3Change() {
            // nothing extra needed
        }
    }
};
</script>
